export default __webpack_public_path__ + "static/media/download-white.e941fddf.svg";